import DailyAttendance from "./DailyAttendance";
export default DailyAttendance;